import { createContext } from 'react'

const DataTreatmentModalContext = createContext()

export default DataTreatmentModalContext
